import { Tag, Tooltip } from "antd";

export const RATING_OPTIONS = [
  {
    value: 1,
    label: "Katastrofa",
    color: "#2C2C2C",
    description: "Bardzo złe, bolesne w odbiorze, strata czasu.",
  },
  {
    value: 2,
    label: "Słabe",
    color: "#B71C1C",
    description: "Wyraźnie nieudane, niska jakość.",
  },
  {
    value: 3,
    label: "Takie sobie",
    color: "#E65100",
    description: "Ma pojedyncze zalety, lecz całość rozczarowuje.",
  },
  {
    value: 4,
    label: "Przeciętne",
    color: "#F9A825",
    description: "Poprawne, ale bez większych emocji.",
  },
  {
    value: 5,
    label: "Dobre",
    color: "#7CB342",
    description: "Solidne, udane, warte polecenia.",
  },
  {
    value: 6,
    label: "Bardzo dobre",
    color: "#2E7D32",
    description: "Wysoki poziom, świetna jakość, pełna satysfakcja z odbioru.",
  },
  {
    value: 7,
    label: "Rewelacyjne",
    color: "#1565C0",
    description:
      "Prawie perfekcyjne, robi ogromne wrażenie, drobne niedociągnięcia.",
  },
  {
    value: 8,
    label: "Arcydzieło",
    color: "#6A1B9A",
    description:
      "Dzieło wybitne, ponadczasowe, najwyższa jakość artystyczna i wykonawcza.",
  },
] as const;

export const MAX_RATING = 8;

export function getRatingInfo(rating: number | null | undefined) {
  if (!rating || rating < 1 || rating > MAX_RATING) return null;
  return RATING_OPTIONS.find((opt) => opt.value === rating) || null;
}

interface RatingDisplayProps {
  value: number | null | undefined;
  showLabel?: boolean;
}

export function RatingDisplay({ value, showLabel = true }: RatingDisplayProps) {
  const info = getRatingInfo(value);
  if (!info)
    return <span style={{ color: "#686D64", fontSize: 12 }}>Brak oceny</span>;

  const tooltipText = `${info.value} na ${MAX_RATING} — ${info.description}`;

  const tag = (
    <Tag
      style={{
        margin: 0,
        fontWeight: 500,
        backgroundColor: info.color,
        color: info.value === 4 || info.value === 5 ? "#252824" : "#fff",
        border: "none",
      }}
    >
      {showLabel ? info.label : info.value}
    </Tag>
  );

  return <Tooltip title={tooltipText}>{tag}</Tooltip>;
}

export default RatingDisplay;
